import { customers } from './customers';
import { salesforce } from './salesforce';
import { subscriptions } from './subscriptions';
import { trials } from './trials';

export const v1 = {
  customers,
  salesforce,
  subscriptions,
  trials,
};
